import * as React from 'react';
import { useLocation } from "react-router-dom";
import CircularProgress from '@mui/material/CircularProgress';
import { Stack, Typography } from '@mui/material';
import EditComp from '../util/EditComp';
import Service from '../../util/Service';
import EditarPaginaHtml from './editar/EditarPaginaHtml';
import HtmlContent from '../util/HtmlContent';
import PaginaHtmlDinamica from './PaginaHtmlDinamica';

export default function PaginaHtml(props) {
    const { edit } = props;
    const location = useLocation();
    const [wait, setWait] = React.useState(true);
    const [pagina, setPagina] = React.useState();

    // const [openEditar, setOpenEditar] = React.useState(false);

    // React.useEffect(() => {

    // }, [])
    console.log('>>>PaginaHtml<<<')
    React.useEffect(() => {
        const path = location.pathname.split("/").slice(1);

        if (!path) return false;
        const p = path[1];
        buscaPagina(p);
    }, [location])

    function buscaPagina(p) {
        setWait(true);
        Service.GET("/api/paginaHtml/buscaPorNome/" + p+window.location.search).then(r => {
            if (r && r.length > 0) setPagina(r[0]);
            else setPagina();
            setWait(false)
        })
    }

    function handleEditarPagina() {
        // setOpenEditar(true);
    }

    if (wait) {
        return (
            <center style={{ marginTop: '10%' }}>
                <CircularProgress color="inherit" />
            </center>
        )
    }
    
    if (!wait && !pagina) {
        return (
            <div style={{
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                width: '100vw',
                height: '85vh'
            }}
            >
                <Typography variant="h4">Pagina não encontrada!</Typography>
            </div>
        )
    }
    if (pagina && pagina.controller) {
        return (
            <PaginaHtmlDinamica edit={edit} rootPage={pagina} />
        )
    }
    return (
        <div>
            <EditComp tip="Editar Pagina" action={handleEditarPagina} edit={edit} />
            <Stack>
                <HtmlContent htmlString={pagina ? pagina.pagina : ''} edit={edit} />
            </Stack>
            <EditarPaginaHtml 
                // open={openEditar} setOpen={setOpenEditar} doAction={handelDoAction} pagina={pagina} 
            />
        </div>
    )
}
